import { FC, useMemo } from 'react';
import { Grid, Typography } from '@material-ui/core';
import clsx from 'clsx';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useStyles } from './styles';
import { RootReducer, StreamingReducer } from '../../../../models/Redux';
import useDominantSpeaker from '../../hooks/useDominantSpeaker/useDominantSpeaker';

interface DominantSpeakerOverlayProps {
    mobileLayout?: boolean;
    hideAvatar?: boolean;
}

const DEFAULT_AVATAR_PLACEHOLDER = 'https://api.gotmy.com/public/static/img/user/generic.png';

const DominantSpeakerOverlay: FC<DominantSpeakerOverlayProps> = ({ hideAvatar, mobileLayout }) => {
    const classes = useStyles();
    const {
        streamingState: { current_state: currentState },
    } = useSelector<RootReducer, StreamingReducer>(state => state.streaming);

    const dominantSpeaker = useDominantSpeaker();
    const { t } = useTranslation();

    const dominantSpeakerAvatar = useMemo(() => {
        if (dominantSpeaker?.identity === currentState?.influencer?.username) {
            return currentState?.influencer?.user_avatar;
        }
        if (dominantSpeaker?.identity) {
            return (
                currentState?.viewers?.find(viewer => viewer?.username === dominantSpeaker?.identity)
                    ?.user_avatar || DEFAULT_AVATAR_PLACEHOLDER
            );
        }
        return DEFAULT_AVATAR_PLACEHOLDER;
    }, [currentState, dominantSpeaker]);

    return (
        <Grid
            container
            xs={12}
            justify="flex-end"
            alignContent="center"
            alignItems="center"
            direction="row"
            className={clsx(mobileLayout ? classes.mobileContainer : classes.container)}
        >
            {dominantSpeaker && (
                <Grid
                    xs={1}
                    container
                    justify="center"
                    alignContent="center"
                    alignItems="center"
                    direction="column"
                    className={clsx(
                        mobileLayout
                            ? classes.dominantSpeakerMobileContainer
                            : classes.dominantSpeakerContainer,
                    )}
                >
                    {!hideAvatar && <img src={dominantSpeakerAvatar} alt="Speaking user avatar" />}
                    <Typography className={classes.dominantSpeakerText}>
                        {dominantSpeaker?.identity} <br /> {t('is speaking')}
                    </Typography>
                </Grid>
            )}
        </Grid>
    );
};

export default DominantSpeakerOverlay;
